export default {
  Incomplete: 0,
  Complete: 1,
};
